module.exports = __webpack_public_path__ + "static/media/video_verfication_audio.c29ee45e.mp3";